export default "/images/icon-ai-text.gif?9a71591a4b2a50a259eb111bfc1ae911";